import { createContext, useContext } from 'react';
import { atom } from 'jotai';
import type { BackgroundWorkItem } from '@localagent/sdk';

export const focusedActivityNodeAtom = atom<{ nodeId: string; at: number } | null>(null);

export const OpenRunningWorkContext = createContext<((item: BackgroundWorkItem) => void) | null>(null);

export function useOpenRunningWork(): ((item: BackgroundWorkItem) => void) | null {
  return useContext(OpenRunningWorkContext);
}
